/**
 * Shorten UUID to 8-char prefix for clean URLs.
 * Full UUID: 50708e77-3db6-4124-af77-7bb12998b489
 * Short:     50708e77
 */
export function sid(uuid) {
  if (!uuid) return '';
  return String(uuid).replace(/-/g, '').slice(0, 8);
}
